import React from 'react';
import * as Yup from 'yup';
import { HandleFormDetail, TextInput, Selection } from 'components';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import ApiServices from 'services';

const FORM_WIDTH = '500px';
export const FormDetail = ({ selected, setSelected, initData, ...props }) => {
  const createFn = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const { status } = await ApiServices.createPermissionMemberGroup(values);
      if (status === 200) {
        window.UIMessage?.success('Thêm mới thành công');
        setSelected(null);
        initData();
      } else {
        window.UIMessage?.error('Thêm mới thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  const updateFn = async (values, { setSubmitting }) => {
    delete values.updatedOn;
    setSubmitting(true);
    try {
      const { data } = await ApiServices.updatePermissionMemberGroup(values.id, values);
      if (data) {
        window.UIMessage?.success('Cập nhật thành công');
        setSelected(null);
        initData();
      } else {
        window.UIMessage?.error('Cập nhật thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  return (
    <>
      <HandleFormDetail
        {...{ selected, setSelected, width: FORM_WIDTH }}
        showTitleTab={selected?.isNew ? 'Tạo mới' : `Nhóm: ${selected?.name}`}
      >
        <Formik
          initialValues={{
            code: '',
            name: '',
            desc: '',
            companyId: '',
            ...selected,
          }}
          validationSchema={Yup.object().shape({
            code: Yup.string()
              .max(15, 'Mã chỉ được nhập tối đa 15 ký tự')
              .required('Vui lòng nhập mã nhóm!!!'),
            name: Yup.string().max(255).required('Vui lòng nhập tên nhóm'),
            companyId: Yup.string().max(255).required('Vui lòng chọn công ty'),
          })}
          onSubmit={(values, { setSubmitting }) => {
            if (selected?.isNew) {
              createFn(values, { setSubmitting });
            } else {
              updateFn(values, { setSubmitting });
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <TextInput
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code}
                label="Mã"
                name="code"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                disabled={!selected?.isNew}
              />
              <TextInput
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
                label="Tên nhóm"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
              />
              <TextInput
                error={Boolean(touched.desc && errors.desc)}
                helperText={touched.desc && errors.desc}
                label="Desc"
                name="desc"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.desc}
              />
              <Selection
                error={Boolean(touched.companyId && errors.companyId)}
                helperText={touched.companyId && errors.companyId}
                label="Công ty"
                name="companyId"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.companyId}
                syncData={ApiServices.getCompanies}
                fieldView="name"
                fieldValue="id"
              />
              {/* <Selection
                error={Boolean(touched.arrFunctionCode && errors.arrFunctionCode)}
                helperText={touched.arrFunctionCode && errors.arrFunctionCode}
                label="Danh sách chức năng"
                name="arrFunctionCode"
                multiple={true}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.arrFunctionCode}
                syncData={ApiServices.getPermissionSysFuncs}
                fieldView="actionName"
                fieldValue="code"
                disabled={!selected?.isNew}
              />
              <Selection
                error={Boolean(touched.arrMenuCode && errors.arrMenuCode)}
                helperText={touched.arrMenuCode && errors.arrMenuCode}
                label="Danh sách Menu"
                name="arrMenuCode"
                multiple={true}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.arrMenuCode}
                syncData={ApiServices.getPermissionMenus}
                fieldView="name"
                fieldValue="code"
                disabled={!selected?.isNew}
              /> */}
              <Box sx={{ py: 2 }}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="small"
                  type="submit"
                  variant="contained"
                >
                  {selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </HandleFormDetail>
    </>
  );
};
